<template lang="html">
      <div class="shop-gallery section" :data-index="index">
        <swiper :options="swiperOption" ref="swiper" @slide-change="changeIndex()">
          <swiper-slide v-for="(slide, index) in images" :key="slide.id"  @click.prevent="swipeTo(index)">
            <div class="inner">
                    <img :key="index" :src="slide.url" />
            </div>
          </swiper-slide>
        </swiper>
        <div class="pagination">
            <div class="prev" @click="slideToPrev">Previous</div>
            <div>
                  {{ curIndex + 1 }} / {{ totalLength }}
            </div>
            <div class="next" @click="slideToNext">Next</div>
        </div>
      </div>
    </template>
    
    <script>
    import 'swiper/dist/css/swiper.css'
    import {
      swiper,
      swiperSlide
    } from 'vue-awesome-swiper'

    export default {
      props: {
            images: Object,
            index: Number,
      },
      components: {
            swiper,
            swiperSlide,
      },
      data() {
        return {
          x: 0,
          y: 0,
          next: false,
          prev: false,
          open: false,
          close: false,
          curIndex: 0,
          mouseActive: false,
          swiperOption: {
            preloadImages: false,
            mousewheel: true,
            speed: 700,
            loop: true,
            slidesPerView: 3.5,
            grabCursor: true,
            spaceBetween: 30,
            centeredSlides: true,
            breakpoints: {
                  '768': {
                        slidesPerView: 2,
                  },
                  '1024': {
                        slidesPerView: 3.5,
                  }
            }
          }
        }
      },
      computed: {
            totalLength() {
                  return Object.keys(this.images).length
            },
            swiper() {
                  return this.$refs.swiper.swiper
            }
      },
      methods: {
            click(event) {
                  if (this.$route.name === 'projects') {
                        let section = event.target.closest('.section')
                        if (this.index == section.dataset.index) {
                              if (event.clientX > (window.innerWidth / 2)) {
                                    this.slideToNext()
                              } else {
                                    this.slideToPrev()
                              }
                        }
                  }
            },
            slideToNext() {
                  this.swiper.slideNext()
                  this.curIndex = this.swiper.realIndex
            },
            slideToPrev() {
                  this.swiper.slidePrev()
                  this.curIndex = this.swiper.realIndex
            },
            slideTo(index) {
                  this.swiper.slideTo(index)
                  this.curIndex = this.swiper.realIndex
            },
            changeIndex() {
                  this.curIndex = this.swiper.realIndex
            }
      }
    }
    </script>
    
    <style lang="scss" scoped>
    .shop-gallery {
        width: 100%;
        height: 34vw;
        scroll-snap-align: start;
        position: relative;
      //   cursor: none;
        @media only screen and (max-width: 768px) {
            cursor: auto;
            height: 68vw;
        }
        &:last-of-type {
            margin-bottom: 0;
        }
        .pagination {
            width: auto;
            display:flex;
            position: absolute;
            bottom: 0;
            transform: translateY(100%);
            left: 0;
            padding: 1em;
            .prev {
                  margin-right:1rem;
                  cursor:pointer;
            }
            .next {
                  margin-left:1rem;
                  cursor:pointer;
            }
      }
    }
    .swiper-container,
    .swiper-wrapper {
        height: 100%;
    }
    .swiper-slide,
    .swiper-slide-duplicate {
        .inner {
            height: 100%;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                object-position: center center;
            }
        }
    
    }

    .project-title {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        padding: 0.5rem;
        z-index: 101;
        cursor: pointer;
        span {
            position: relative;
            display: inline-block;
            transition: transform 0.2s;
        }
        &:hover {
            span {
                &:nth-of-type(2) {
                    transform: translate(0, -1rem);
                }
                &:nth-of-type(4) {
                    transform: translate(0, -1.5rem);
                }
                &:nth-of-type(6) {
                    transform: translate(0, -0.75rem);
                }
                &:nth-of-type(9) {
                    transform: translate(0, -1rem);
                }
                &:nth-of-type(11) {
                    transform: translate(0, -1.5rem);
                }
                &:nth-of-type(13) {
                    transform: translate(0, -0.75rem);
                }
                &:nth-of-type(15) {
                    transform: translate(0, -0.75rem);
                }
                &:nth-of-type(18) {
                    transform: translate(0, -0.75rem);
                }
            }
        }
        @media only screen and (max-width: 768px) {
            left: auto;
            transform: none;
            right: 0;
        }
    
    }
    </style>
    